import { useEffect } from "react";
import { useInitialization } from "Providers/InitializationProvider";
import { useCalendar } from "./hooks/useCalendar";

export const CalendarInitializer = () => {
	const { initialDate, initialCalendarType } = useInitialization();
	
	useEffect(() => {
		// Initialize the calendar with the validated state
		useCalendar.getState().initializeWithState(initialDate, initialCalendarType);
	}, [initialDate, initialCalendarType]);
	
	return null;
}; 